/* eslint-disable no-bitwise */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-var */
import moment from 'moment';
import momentTz from 'moment-timezone';

import {
  appRegex as _appRegex,
  DEFAULT_ERROR_MESSAGE,
  DEFAULT_FIELD_VALIDATION_TYPE,
  appStorage as AppStorage
} from '@config/AppConfig';
import * as yup from 'yup';

// App modes
export const appEnvMode = {
  NODE_ENV_DEV: 'development',
  NODE_ENV_PROD: 'production',
  NODE_ENV_STAGE: 'stage'
};

export const headerStringRoute = {
  DASHBOARD: 'dashboard',
  TARIFF: 'tariff',
  CHARGES: 'charges',
  HELP_AND_SERVICE: 'help-service',
  ACCOUNT: 'account'
};

// Extend routes
export const appRoute = {
  // Public Routes
  // ...commonRoutes
  // ,
  HOME_PAGE: '/',
  ACTIVATION: '/activation',
  ACTIVATION_WELCOME: '/activation-welcome',
  ACTIVATION_PAYMENT_CALLBACK: '/activation/payment-verification',
  NOT_FOUND: '/404',
  FORGOT_PASSWORD: '/forgot-password',

  APP_REVIEW_REDIRECT: '/store-review',
  STORE_REDIRECT: '/dl',

  // test routes for development and staging
  TEST: '/test',

  // Private Routes
  // CLEANUP: remove after testing
  // #region private Routes
  // DASHBOARD: '/dashboard',
  // BOOKABLE_DATA: '/dashboard/options',
  // FORCE_PASSWORD_CHANGE: '/force-password-change',

  // USER_ACCOUNT: '/account',
  // PREFERENCES: '/account/preferences',
  // ADVANTAGES: '/account/advantages',
  // TRUE_BONUS: '/account/advantages/true-bonus',
  // BIRTHDAY: '/account/advantages/birthday',
  // INSIDE_BONUS: '/account/advantages/inside-bonus',
  // ADVANTAGE_AUTOTOPUP: '/account/advantages/auto-topup',
  // PROFILE: '/account/profile',
  // CHANGE_USER_INFO: '/account/profile/change-user-info',
  // CHANGE_PASSWORD: '/account/profile/change-password',
  // CHANGE_HOTLINE: '/account/profile/change-hotline-password',
  // HELP_AND_SERVICE: '/help-service',
  // TARIFF_DETAILS: '/account/tariff-details',
  // CONTACT: '/help-service/contact',
  // EXPLAINER_VIDEO: '/help-service/explainer-video',
  // FAQ: '/help-service/faq',
  // LEGAL: '/help-service/legal',
  // DOCUMENTS: '/help-service/legal/documents',
  // PRIVACY_DOCS: '/help-service/legal/privacy-documents',
  // IMPRINT: '/help-service/legal/imprint',
  // FOOT_NOTES: '/help-service/legal/foot-notes',
  // CANCEL_CONTRACT: '/help-service/cancel-contract',
  // LOCK_UNLOCK_SIM: '/help-service/lock-unlock-sim',
  // CHARGES: '/charges',
  // TOPUP_HISTORY: '/charges/topup-history',
  // VOUCHER_HISTORY: '/charges/voucher-history',
  // RECHARGE_CREDIT: '/charges/recharge-credit',
  // RECHARGE_VOUCHER: '/charges/recharge-credit/recharge-voucher',
  // SET_AUTO_TOPUP: '/charges/recharge-credit/setup-auto-topup',
  // SET_DIRECT_TOPUP: '/charges/recharge-credit/setup-direct-topup',
  // PAYMENT_CALLBACK: '/payment',

  // ESIM_TARIFF: '/esim-tariff',
  // TARIFF_OPTION: '/tariff',
  // TARIFF_CHANGE: (id) => (id ? `/tariff/change/${id}` : '/tariff/change/:tariffId'),

  // OPTION_BOOK: (id) => (id ? `/dashboard/option/book/${id}` : '/dashboard/option/book/:optionId'),
  // SPEEDON_BOOK: (id) =>
  //   id ? `/dashboard/speedon/book/${id}` : '/dashboard/speedon/book/:speedonId',
  // PASSOFFER_BOOK: (passCode) =>
  //   passCode ? `/dashboard/passoffer/book/${passCode}` : '/dashboard/passoffer/book/:passCode',
  // DATAPASS_BOOK: (id) =>
  //   id ? `/dashboard/datapass/book/${id}` : '/dashboard/datapass/book/:datapassId',
  // ROAMING_BOOK: (id) =>
  //   id ? `/dashboard/roaming/book/${id}` : '/dashboard/roaming/book/:roamingId'
    // #endregion
};
export const storageKeys = {
  // ...commonRoutes,
  CODE: 'code',
  SESSION_STATE: 'session_state',
  X_LOG_TAG: 'x_log_tag'
};

export const appStorage = {
  ...AppStorage,
  CART_NAME: 'cartName',
  ORDER_NUMBER: 'orderNumber',
  ACTIVATION_DATA: 'activationData',
  ACTIVATION_PERSONAL_DATA: 'activationPersonalData',
  ACTIVATION_MSISDN: 'activationMsisdn',
  POSTIDENT: 'postIdent',
  LEGITIMATION_URL: 'legitimationUrl',
  LEGITIMATION_CODE: 'legitimationCode',
  LEGITIMATION_NAME: 'legitimationName',
  TARIFF_SHOWN_TIME: 'tarrifShownTime',
  PREFERENCE_SHOW_TIME: 'preferenceShowTime',
  NAVIGATE_TO: 'navigateTo',
  PAYMENT_TOKEN: 'payment-token',
  PAYMENT_REFRESH_TOKEN: 'payment-refresh-token',
  PAYMENT_REASON: 'payment-reason',
  TOPUP_TYPE: 'topupType',
  TOPUP_AMOUNT: 'topupAmount',
  MSISDN: 'msisdn'
};

// App alert types
export const appAlert = {
  DEFAUT_TIMEOUT: 4000,
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info',
  LIGHT: 'light',
  DARK: 'dark',
  SUCCESS: 'success',
  ERROR: 'danger'
};

export const notificationType = {
  VARIANT1: 'variant1',
  VARIANT2: 'variant2',
  VARIANT3: 'variant3'
};

// App alert types
export const appDefaultAlertMessage = {
  SUCCESS: 'success',
  ERROR: 'error',
  ERROR_NOT_FOUND: 'Not able to found your last request',
  ERROR_UNAUTH: 'Please login to continue!',
  INFO: 'info',
  WARNING: 'warning'
};

export const appIcons = {
  HOME: 'Home',
  DASHBOARD: 'Dashboard',
  RADIO_ACTIVE: 'RadioActive',
  FOCUS_YES: 'FocusYes',
  FOCUS_NO: 'FocusNo',
  APPSTORE: 'AppStore',
  BASKET: 'Basket',
  STORE: 'Store',
  DATA: 'Data',
  ROAMING: 'Roaming',
  BDAY: 'Bday',
  COMMUNICATION: 'Communication',
  LAUFZEIT: 'Laufzeit',
  CONTRACT: 'Contract',
  BENEFIT: 'Benefit',
  PAYPAL: 'Paypal',
  GIROPAY: 'Giropay',
  SEPA: 'Sepa',
  KLARNA: 'Klarna',
  GIROPAY2: 'Giropay2',
  SOFORT: 'Sofort',
  VISA_MASTER: 'VisaMaster',
  AMERICAN_EXPRESS: 'AmericanExpress',
  APPLE_PAY: 'ApplePay',
  GOOGLE_PAY: 'GooglePay',
  PAYDIREKT: 'Paydirekt',
  ERROR: 'Error',
  CORRECT: 'Correct',
  WARNING: 'Warning',
  HOME_ACTIVE_NO: 'HomeActiveNo',
  HOME_ACTIVE_YES: 'HomeActiveYes',
  KONTO_ACTIVE_NO: 'KontoActiveNo',
  KONTO_ACTIVE_YES: 'KontoActiveYes',
  TARIFF_ACTIVE_NO: 'TariffActiveNo',
  TARIFF_ACTIVE_YES: 'TariffActiveYes',
  NEWS_ACTIVE_NO: 'NewsActiveNo',
  NEWS_ACTIVE_YES: 'NewsActiveYes',
  TOPUP_ACTIVE_NO: 'TopupActiveNo',
  TOPUP_ACTIVE_YES: 'TopupActiveYes',
  ANGRY: 'Angry',
  SMS_PASSWORT: 'SmsPasswort',
  PAYMENT: 'Payment',
  SUCCESS: 'Success',
  TEA: 'Tea',
  HOURGLASS: 'Hourglass',
  LOCKED: 'Locked',
  MAIL: 'Mail',
  PAY: 'Pay',
  GESCHENKEWAGEN: 'Geschenkewagen',
  CAUTION: 'Caution',
  PAUSE: 'Pause',
  SENT: 'Sent',
  ARROW_BACK: 'ArrowBack',
  ARROW_FORWARD: 'ArrowForward',
  ARROW_LEFT_SMALL: 'Variant25',
  ARROW_RIGHT_SMALL: 'ArrowRightSmall',
  LOGOUT: 'Logout',
  CHANGED: 'Changed',
  COPY_ALT: 'CopyAlt',
  UNLIMITED: 'Unlimited',
  VOUCHER: 'Voucher',
  PLUS: 'Plus',
  RESEARCH: 'ReSearch',
  PLAY: 'Play',
  STAR: 'Star',
  HOTLINE_PASSWORD: 'HotlinePassword',
  SIGNOUT: 'Signout',
  GIFT: 'Gift',
  PERCENT: 'Percent',
  PLAY2: 'Play2',
  ADD: 'Add',
  CLOSE: 'Close',
  ASK: 'Ask',
  SUPPORT: 'Support',
  JUSTICE: 'Justice',
  CAUTION2: 'Caution2',
  REWARD: 'Reward',
  ALARM: 'Alarm',
  DOCUMENT: 'Document',
  WAIT: 'Wait',
  WECHSEL: 'Wechsel',
  BELL: 'Bell',
  ACTIVE: 'Active',
  MARKER1: 'Marker1',
  KEY1: 'Key1',
  ENVELOPE: 'Envelope',
  EVN: 'Evn',
  PERSONAL_DATA: 'PersonalData',
  CLOCK: 'Clock',
  AUTOMATIC: 'Automatic',
  SIM: 'Sim',
  ESIM: 'Esim',
  REFRESH: 'Refresh',
  ARROW_LEFT_SM: 'ArrowLeftSm',
  ARROE_RIGHT_SM: 'ArrowRightSm',
  TOPUP: 'Topup',
  COPY: 'Copy',
  TOPUP2: 'Topup2',
  EDIT: 'Edit',
  NEWS: 'News',
  PROFILE: 'Profile',
  DOWNLOAD: 'Download',
  CHECK: 'Check',
  CHECK2: 'Check2',
  HIDE: 'Hide',
  SHOW: 'Show',
  LOCK: 'Lock',
  UNLOCK: 'Unlock',
  INFO: 'Info',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  CHANGE: 'Change',
  CANCEL: 'Cancel',
  ATTENTION: 'Attention',
  ARROW_RIGHT: 'ArrowRight',
  TRASH: 'Trash',
  EMPLOYEE: 'Employee',
  SEARCH: 'Search',
  PHONE_CALL: 'PhoneCall',
  FACE_ID: 'FaceId',
  CART: 'Cart',
  PAYBACK: 'Payback',
  IDEA: 'Idea',
  DATE: 'Date'
};

export const appTextFieldLabelClass = {
  V1: 'v1',
  V2: 'v2'
};

export const appTextInputClass = {
  V1: 'v1',
  V2: 'v2'
};

export const appIconsPath = {
  HOME: '/assets/images/icons/home.svg',
  ALPHACOMM_LOGO: '/assets/images/logos/alphacomm-logo.svg',
  FOCUS_YES: '/assets/images/icons/add-focus-no.svg',
  FOCUS_NO: '/assets/images/icons/add-focus-yes.svg',
  APPSTORE: '/assets/images/icons/appstore.svg',
  BASKET: '/assets/images/icons/basket.svg',
  STORE: '/assets/images/icons/store.svg',
  DATA: '/assets/images/icons/data.svg',
  ROAMING: '/assets/images/icons/roaming.svg',
  BDAY: '/assets/images/icons/bday.svg',
  COMMUNICATION: '/assets/images/icons/communication.svg',
  LAUFZEIT: '/assets/images/icons/laufzeit.svg',
  CONTRACT: '/assets/images/icons/contract.svg',
  BENEFIT: '/assets/images/icons/benefit.svg',
  PAYPAL: '/assets/images/icons/paypal.svg',
  GIROPAY: '/assets/images/icons/giropay.svg',
  SEPA: '/assets/images/icons/sepa.svg',
  KLARNA: '/assets/images/icons/klarna.svg',
  GIROPAY2: '/assets/images/icons/giropay2.svg',
  SOFORT: '/assets/images/icons/sofort.svg',
  VISA_MASTER: '/assets/images/icons/visa-master.svg',
  AMERICAN_EXPRESS: '/assets/images/icons/american_express.svg',
  PAYDIREKT: '/assets/images/icons/paydirekt.svg',
  ERROR: '/assets/images/icons/error.svg',
  ONLINE: '/assets/images/icons/online.svg',
  CORRECT: '/assets/images/icons/correct.svg',
  WARNING: '/assets/images/icons/warning.svg',
  HOME_ACTIVE_NO: '/assets/images/icons/home-active-no.svg',
  HOME_ACTIVE_YES: '/assets/images/icons/home-active-yes.svg',
  KONTO_ACTIVE_NO: '/assets/images/icons/konto-active-no.svg',
  KONTO_ACTIVE_YES: '/assets/images/icons/konto-active-yes.svg',
  TARIFF_ACTIVE_NO: '/assets/images/icons/tariff-active-no.svg',
  TARIFF_ACTIVE_YES: '/assets/images/icons/tariff-active-yes.svg',
  NEWS_ACTIVE_NO: '/assets/images/icons/news-active-no.svg',
  NEWS_ACTIVE_YES: '/assets/images/icons/news-active-yes.svg',
  TOPUP_ACTIVE_NO: '/assets/images/icons/topup-active-no.svg',
  TOPUP_ACTIVE_YES: '/assets/images/icons/topup-active-yes.svg',
  ANGRY: '/assets/images/icons/angry.svg',
  SMS_PASSWORT: '/assets/images/icons/sms_passwort.svg',
  PAYMENT: '/assets/images/icons/payment.svg',
  SUCCESS: '/assets/images/icons/success.svg',
  TEA: '/assets/images/icons/tea.svg',
  HOURGLASS: '/assets/images/icons/hourglass.svg',
  LOCKED: '/assets/images/icons/locked.svg',
  MAIL: '/assets/images/icons/mail.svg',
  PAY: '/assets/images/icons/pay.svg',
  GESCHENKEWAGEN: '/assets/images/icons/geschenkewagen.svg',
  CAUTION: '/assets/images/icons/caution.svg',
  PAUSE: '/assets/images/icons/pause.svg',
  SENT: '/assets/images/icons/sent.svg',
  ARROW_BACK: '/assets/images/icons/arrow-back.svg',
  ARROW_FORWARD: '/assets/images/icons/arrow-forward.svg',
  ARROW_LEFT_SMALL: '/assets/images/icons/variant25.svg',
  ARROW_RIGHT_SMALL: '/assets/images/icons/arrow-rightt-small.svg',
  LOGOUT: '/assets/images/icons/logout.svg',
  CHANGED: '/assets/images/icons/changed.svg',
  COPY_ALT: '/assets/images/icons/copy-alt.svg',
  UNLIMITED: '/assets/images/icons/unlimited.svg',
  VOUCHER: '/assets/images/icons/voucher.svg',
  PLUS: '/assets/images/icons/plus.svg',
  RESEARCH: '/assets/images/icons/research.svg',
  PLAY: '/assets/images/icons/play.svg',
  STAR: '/assets/images/icons/star.svg',
  HOTLINE_PASSWORD: '/assets/images/icons/hotline-password.svg',
  SIGNOUT: '/assets/images/icons/signout.svg',
  GIFT: '/assets/images/icons/gift.svg',
  PERCENT: '/assets/images/icons/percent.svg',
  PLAY2: '/assets/images/icons/play-2.svg',
  ADD: '/assets/images/icons/add.svg',
  CLOSE: '/assets/images/icons/close.svg',
  ASK: '/assets/images/icons/ask.svg',
  SUPPORT: '/assets/images/icons/support.svg',
  JUSTICE: '/assets/images/icons/justice.svg',
  CAUTION2: '/assets/images/icons/caution2.svg',
  REWARD: '/assets/images/icons/reward.svg',
  ALARM: '/assets/images/icons/alarm.svg',
  DOCUMENT: '/assets/images/icons/document.svg',
  WAIT: '/assets/images/icons/wait.svg',
  WECHSEL: '/assets/images/icons/wechsel.svg',
  BELL: '/assets/images/icons/bell.svg',
  ACTIVE: '/assets/images/icons/active.svg',
  MARKER1: '/assets/images/icons/marker.svg',
  KEY1: '/assets/images/icons/key.svg',
  ENVELOPE: '/assets/images/icons/envelope.svg',
  EVN: '/assets/images/icons/evn.svg',
  PERSONAL_DATA: '/assets/images/icons/personal-data.svg',
  CLOCK: '/assets/images/icons/clock.svg',
  AUTOMATIC: '/assets/images/icons/automatic.svg',
  SIM: '/assets/images/icons/sim.svg',
  ESIM: '/assets/images/icons/esim.svg',
  REFRESH: '/assets/images/icons/refresh.svg',
  ARROW_LEFT_SM: '/assets/images/icons/arrow-left-sm.svg',
  ARROE_RIGHT_SM: '/assets/images/icons/arrow-right-sm.svg',
  TOPUP: '/assets/images/icons/topup.svg',
  COPY: '/assets/images/icons/copy.svg',
  TOPUP2: '/assets/images/icons/topup-2.svg',
  EDIT: '/assets/images/icons/edit.svg',
  NEWS: '/assets/images/icons/news.svg',
  PROFILE: '/assets/images/icons/profile.svg',
  DOWNLOAD: '/assets/images/icons/download.svg',
  CHECK: '/assets/images/icons/check.svg',
  CHECK2: '/assets/images/icons/check2.svg',
  HIDE: '/assets/images/icons/hide.svg',
  SHOW: '/assets/images/icons/show.svg',
  LOCK: '/assets/images/icons/lock.svg',
  UNLOCK: '/assets/images/icons/unlock.svg',
  INFO: '/assets/images/icons/info.svg',
  ARROW_LEFT: '/assets/images/icons/arrow-left.svg',
  ARROW_DOWN: '/assets/images/icons/arrow-down.svg',
  ARROW_UP: '/assets/images/icons/arrow-up.svg',
  CHANGE: '/assets/images/icons/change.svg',
  CANCEL: '/assets/images/icons/cancel.svg',
  ATTENTION: '/assets/images/icons/attention.svg',
  ARROW_RIGHT: '/assets/images/icons/arrow-right.svg',
  TRASH: '/assets/images/icons/trash.svg',
  EMPLOYEE: '/assets/images/icons/employee.svg',
  SEARCH: '/assets/images/icons/search.svg',
  PHONE_CALL: '/assets/images/icons/phone-call.svg',
  FACE_ID: '/assets/images/icons/face-id.svg',
  CART: '/assets/images/icons/cart.svg',
  PAYBACK: '/assets/images/icons/payback.svg',
  IDEA: '/assets/images/icons/idea.svg',
  DATE: '/assets/images/icons/date.svg',
  SMARTPHONE: '/assets/images/icons/16/smartphone.svg',
  CELEBRATE: '/assets/images/icons/celebrate.svg',
  INFO_MESSAGE: '/assets/images/icons/info-message.svg',
  EMAIL_HAPPY: '/assets/images/icons/email-happy.svg',
  CHECK_GREEN_OUTLINED: '/assets/images/icons/check-green-outlined.svg',
  PERCENTAGE: '/assets/images/icons/percentage.svg',
  USER_SHILD: '/assets/images/icons/24/user-shild.svg',
  APPLE_PAY: '/assets/images/icons/icon-applepay.svg',
  GOOGLE_PAY: '/assets/images/icons/icon-googlepay.svg',
  OPEN_BANKING: '/assets/images/icons/icon-openbanking.svg',
  ARROW_RIGHT_SMALL_RED: '/assets/images/icons/16/arrow-right-red.svg'
};

export const appImages = {
  logoEdekaBlue: '/assets/images/logos/edeka_smart-logo-blue.svg',
  logoEdekaWhite: '/assets/images/logos/edeka_smart-logo-white.svg',
  logoAlphacommV1: '/assets/images/logos/alphacomm-logo-v1.svg',
  logoAlphacommV2: '/assets/images/logos/alphacomm-logo-v2.svg',
  logoSeals: '/assets/images/logos/logo_seals.svg',
  iosStore: '/assets/images/ios-app.svg',
  androidStore: '/assets/images/android-app.svg',
  postident: '/assets/images/postident.png',
  nect: '/assets/images/nect.png',
  cardImage: '/assets/images/card.png'
};

export const appKeyCode = {
  ESCAPE: 27,
  ENTER: 13,
  SPACE: 32,
  ARROW_DOWN: 40,
  ARROW_UP: 38,
  HOME: 36,
  END: 35,
  TAB: 9,
  ARROW_RIGHT: 39,
  ARROW_LEFT: 37,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  BACKSPACE: 8
};

export const appButtonType = {
  PRIMARY: 'btn btn-primary',
  SECONDARY: 'btn btn-secondary',
  WHITE: 'btn btn-white',
  LINK: 'btn btn-link'
};

export const appLinkStyle = {
  PRIMARY: 'text-primary',
  SECONDARY: 'text-secondary',
  WHITE: 'text-ek-white'
};

export const appLinkSize = {
  LARGE: 'ek-copy-16-medium-underlined',
  SMALL: 'ek-labeltext-12-medium underlined',
  DEFAULT: 'ek-copy-sm-14-medium-underlined'
};

export const appRadioSize = {
  LARGE: 'ek-copy-16-regular',
  SMALL: 'ek-labeltext-12-regular',
  DEFAULT: 'ek-copy-sm-14-regular'
};

export const appCheckboxSize = {
  LARGE: 'ek-copy-16-regular',
  SMALL: 'ek-labeltext-12-regular',
  DEFAULT: 'ek-copy-sm-14-regular'
};

export const appToggleSize = {
  LARGE: 'ek-copy-16-medium',
  SMALL: 'ek-labeltext-12-medium',
  DEFAULT: 'ek-copy-sm-14-medium'
};

export const appCardStyle = {
  DEFAULT: 'bg-ek-white text-primary',
  DEFAULT_GRADIENT: 'bg-ek-glass text-primary border border-white',
  PRIMARY: 'bg-primary text-white',
  PRIMARY_GRADIENT: 'bg-ek-gradient text-white',
  SECONDARY: 'bg-secondary text-primary',
  WARNING: 'bg-warning text-primary'
};

export const appBgColor = {
  DEFAULT: 'bg-ek-white',
  DEFAULT_GRADIENT: 'bg-ek-glass',
  PRIMARY: 'bg-primary',
  PRIMARY_GRADIENT: 'bg-ek-gradient',
  SECONDARY: 'bg-secondary',
  WARNING: 'bg-warning'
};

export const appChipStyle = {
  PRIMARY: 'bg-ek-gradient text-white',
  SECONDARY: 'bg-secondary text-primary',
  WHITE: 'bg-white text-primary',
  SUCCESS: 'bg-success text-white',
  WARNING: 'bg-warning text-primary',
  HIGHLIGHT: 'bg-highlight text-primary',
  // ChipTariffBadge:
  1803: 'bg-tariff-talk text-primary',
  1812: 'bg-tariff-kombi-s text-primary',
  1813: 'bg-tariff-kombi-m text-primary',
  1814: 'bg-tariff-kombi-l text-primary',
  1815: 'bg-tariff-kombi-xl text-primary',
  1810: 'bg-tariff-kombi-max text-primary',
  1816: 'bg-tariff-premium text-primary',
  1811: 'bg-tariff-start text-primary'
};

export const appChipSize = {
  DEFAULT: 'ek-labeltext-12-medium p-8 rounded-3',
  LARGE: 'ek-copy-sm-14-semibold py-8 px-16 rounded',
  SMALL: 'ek-labeltext-12-medium py-4 px-8 rounded-3'
};

export const appInfoCardSize = {
  DEFAULT: 'ek-labeltext-12-medium rounded',
  LARGE: 'ek-copy-sm-14-medium rounded-4'
};

export const cardRedirectionType = {
  LINK: 'link',
  BUTTON: 'button'
};

export const formValidation = ({
  type = DEFAULT_FIELD_VALIDATION_TYPE.STRING, //  for which type of validation required
  required = false, // for for required validations
  minLength = false, // provide min length if required
  minLengthError = DEFAULT_ERROR_MESSAGE.fieldValidation.MIN_LENGTH,
  maxLength = false, // provide min length if required
  maxLengthError = DEFAULT_ERROR_MESSAGE.fieldValidation.MAX_LENGTH,
  regex = '', // regex if you want to do matching validation
  errorMessage = DEFAULT_ERROR_MESSAGE.fieldValidation.REQUIRED, // for addtional sub types of valdation which can required messages other than required.
  validErrorMessage = DEFAULT_ERROR_MESSAGE.fieldValidation.INVALID
}) => {
  // Assign the yup schema
  // Default willl be considered as string
  let valid = {};
  switch (type) {
    case DEFAULT_FIELD_VALIDATION_TYPE.ARRAY:
      valid = yup.array();
      break;
    case DEFAULT_FIELD_VALIDATION_TYPE.BOOLEAN:
      valid = yup.boolean();
      break;
    case DEFAULT_FIELD_VALIDATION_TYPE.DATE:
      valid = yup.date();
      break;
    case DEFAULT_FIELD_VALIDATION_TYPE.MIXED:
      valid = yup.mixed();
      break;
    case DEFAULT_FIELD_VALIDATION_TYPE.NUMBER:
      valid = yup.number();
      break;
    case DEFAULT_FIELD_VALIDATION_TYPE.OBJECT:
      valid = yup.object();
      break;
    case DEFAULT_FIELD_VALIDATION_TYPE.STRING:
      valid = yup.string();
      break;
    default:
      valid = yup.string();
      break;
  }

  // Check if required and set error message for it.
  if (required && typeof required === 'string') {
    valid = valid.required(required);
  }

  // Check if minimum length and set error message for it.
  if (minLength) {
    valid = valid.min(minLength, minLengthError);
  }

  // Check if maximum length and set error message for it.
  if (maxLength) {
    valid = valid.max(maxLength, maxLengthError);
  }

  // Check if type is email
  if (type === DEFAULT_FIELD_VALIDATION_TYPE.EMAIL) {
    valid = valid.email(errorMessage);
  }

  // Check if type is url
  if (type === DEFAULT_FIELD_VALIDATION_TYPE.URL) {
    valid = valid.url(errorMessage);
  }

  // Check if type is lowe_case
  if (type === DEFAULT_FIELD_VALIDATION_TYPE.LOWER_CASE) {
    valid = valid.lowercase(errorMessage);
  }

  // Check if type is upper_case
  if (type === DEFAULT_FIELD_VALIDATION_TYPE.UPPER_CASE) {
    valid = valid.uppercase(errorMessage);
  }

  // Check if regex is passed throw invalid error message.
  if (regex) {
    valid = valid.matches(regex, validErrorMessage);
  }

  return valid;
};

export const inputValidation = {
  VALID: 'valid',
  INVALID: 'invalid',

  MIN_ERROR: 'min',
  MAX_ERROR: 'max',

  MIN_MAX_ERROR: 'minMax',

  UPPER_CASE_ERROR: 'uppercase',
  LOWER_CASE_ERROR: 'lowercase',

  NUMBER_ERROR: 'number',
  SPECIAL_CASE_ERROR: 'specific',

  MATCH: 'match'
};

export const appRegex = {
  ..._appRegex,
  validatePwd:
    /^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[?!\"§$%&#_()\[\]{}@*;:,\\/<>|~+-])|(?=.*[a-z])(?=.*[A-Z])(?=.*[?!\"§$%&#_()\[\]{}@*;:,\\/<>|~+-]))([\x21-\xFF]){12,100}$/,
  validatePwdStringLength: /^.{12,100}$/,
  validatePwdUpperOrLowerCase: /(?=.*[a-zA-Z])/,
  validatePwdNumbers: /(?=.*\d)/,
  validatePwdSpecialChar: /(?=.*[?!\"§$%&#_()\[\]{}@*;:,\\/<>|~+-])/
};

// String Length Validations
export function validateStringLength(string, min = 12, max = 64) {
  return `${string}`.length >= min && `${string}`.length <= max;
}

// String Minimum Length Validations
export function validateMinStringLength(string, min = 12) {
  return `${string}`.length >= min;
}

// UpperCase Validations
export function validateUpperCase(string) {
  return appRegex.validateUpperCase.test(string);
}

// LowerCase Validations
export function validateLowerCase(string) {
  return appRegex.validateLowerCase.test(string);
}

// Number Validations
export function validateNumber(string) {
  return appRegex.validateNumbers.test(string);
}

// Special Validations
export function validateSpecial(string) {
  return /(?=.*[!"§$%&#])/.test(string);
}

// Mobile Special Validations
export function validateMobileSpecial(string) {
  return /(?=.*[!$%&#])/.test(string);
}

// Password Validation
export function validatePassword(values) {
  const errors = Object.keys(values).map((controlName) => {
    const string = values[controlName];
    if (!string) {
      return {
        [controlName]: 'required'
      };
    }

    const hasLength = validateStringLength(values.newPassword, 12, 20);
    const hasUpperCase = validateUpperCase(values.newPassword);
    const hasLowerCase = validateLowerCase(values.newPassword);
    const hasNumber = validateNumber(values.newPassword);
    const hasSpecial = validateSpecial(values.newPassword);

    if (!hasLength || !hasUpperCase || !hasLowerCase || !hasNumber || !hasSpecial) {
      return {
        otherErrors: {
          [inputValidation.MIN_MAX_ERROR]: hasLength,
          [inputValidation.UPPER_CASE_ERROR]: hasUpperCase,
          [inputValidation.LOWER_CASE_ERROR]: hasLowerCase,
          [inputValidation.NUMBER_ERROR]: hasNumber,
          [inputValidation.SPECIAL_CASE_ERROR]: hasSpecial,
          [inputValidation.MATCH]: values.newPassword === values.confirmPassword
        }
      };
    }

    if (
      (values.newPassword || values.confirmPassword) &&
      values.newPassword !== values.confirmPassword
    ) {
      return { confirmPassword: 'match_error' };
    }

    return {};
  });
  return Object.assign(...errors);
}

// Password Validation
export function validatePasswordWithKeys(values, firstPasswordKey, confirmPasswordKey) {
  const errors = Object.keys(values).map((controlName) => {
    const string = values[controlName];
    if (!string) {
      return {
        [controlName]: 'required'
      };
    }

    const hasLength = validateStringLength(values[firstPasswordKey], 12, 20);
    const hasUpperCase = validateUpperCase(values[firstPasswordKey]);
    const hasLowerCase = validateLowerCase(values[firstPasswordKey]);
    const hasNumber = validateNumber(values[firstPasswordKey]);
    const hasSpecial = validateSpecial(values[firstPasswordKey]);

    if (!hasLength || !hasUpperCase || !hasLowerCase || !hasNumber || !hasSpecial) {
      return {
        otherErrors: {
          [inputValidation.MIN_MAX_ERROR]: hasLength,
          [inputValidation.UPPER_CASE_ERROR]: hasUpperCase,
          [inputValidation.LOWER_CASE_ERROR]: hasLowerCase,
          [inputValidation.NUMBER_ERROR]: hasNumber,
          [inputValidation.SPECIAL_CASE_ERROR]: hasSpecial,
          [inputValidation.MATCH]: values[firstPasswordKey] === values[confirmPasswordKey]
        }
      };
    }

    if (
      (values[firstPasswordKey] || values[confirmPasswordKey]) &&
      values[firstPasswordKey] !== values[confirmPasswordKey]
    ) {
      return { [confirmPasswordKey]: 'match_error' };
    }

    return {};
  });
  return Object.assign(...errors);
}
export const gettingNumberForGerman = (number = '') => {
  let num = number;
  // eslint-disable-next-line eqeqeq
  if (num.charAt(0) == 0) {
    num = num.substring(1);
  }
  return `+49${num}`;
};

export const appAutoTopUpType = {
  UNIQUE: 'UNIQUE',
  AUTOMATIC: 'AUTOMATIC'
};

export const AutoTopUpFor = {
  ACTIVATION: 'ACTIVATION',
  LOGIN: 'LOGIN'
};

export const appTopUpType = {
  UNIQUE: 'UNIQUE',
  DIRECT: 'DIRECT',
  AUTOMATIC: 'AUTOMATIC'
};

export const appTopUpTo = {
  SELF: 'SELF',
  OTHER: 'OTHER'
};

export const appAutoTopUpPeriodType = {
  LOW_BALANCE: 'LOW_BALANCE',
  ONCE_PER_MONTH: 'ONCE_PER_MONTH',
  RATE: 'FIXED_RATE'
};

export const appPaymentCertainAmount = [5, 10, 15, 20, 50];
export const appPaymentCertainDay = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
  28
];

export const appPaymentTokenStatus = {
  UNCONFIRMED: 'UNCONFIRMED_PAYMENT_TOKEN'
};

export const appPaymentOrderStatus = {
  CREATION_PENDING: 'creationPending',
  FAILED: 'failed',
  SUCCESS: 'success'
};

export const appPaymentProductType = {
  // Currently using
  RECURRING: 'RECURRING',
  LOW_BALANCE: 'LOW_BALANCE',
  DIRECT: 'DIRECT',

  // Extended
  ALL: 'ALL',
  PREPAID: 'PREPAID',
  TOPUP: 'TOPUP',
  CASH_CODE: 'CASH_CODE',
  VOUCHER: 'VOUCHER'
};

// UNUSED
export const appCustomCardClass = {
  PAGE_CARD: 'page-card', // 734px
  ACTIVATION_CARD: 'activation-card', // 412px
  USAGE_CARD: 'usage-card',
  TARIFF_CARD: 'tariff-card',
  ACTIVE_TARIFF_CARD: 'active-tariff-card',
  PROFILE_CARD: 'profile-card',
  OPTION_CARD: 'option-card' // 412px
};

export const appOptionsGroupIDs = {
  TARIFF_OPTION: [350],
  DATA_OPTIONS: [115, 352],
  DAYFLATS: [151],
  SPEED_ONS_PASSES: [152],
  ROAMING: {
    LANDER_ZONE_1: [153],
    LANDER_ZONE_2: [154],
    LANDER_ZONE_3: [155]
  },
  OTHER: [156] // Sprach-Optionen
};

// ETC One API documentation (PDF-file)
// https://rm5.dom.de/projects/tmb/wiki/00_Vendor_API_(EtcOne)

// Customer statuses from ETC One API documentation (PDF-file)
export const appCustomerStatus = {
  NEW: 0,
  ACTIVE: 1,
  CANCELLED: 3,
  NEW_INREALISATION: 5,
  INACTIVE: 6,
  IN_CANCELLATION: 7,
  MNP: 15,
  MARKED_DELETED: 99
};

// Product statuses from ETC One API documentation (PDF-file)
export const appTariffStatus = {
  ACTIVATION_PENDING: 0,
  ACTIVE: 1,
  REJECTED: 2,
  LOCKED: 3,
  LOCK_REQUESTED: 4,
  DEACTIVATION_REQUESTED: 5,
  PAUSED: 6,
  TERMINATION_REQUESTED: 7,
  UNLOCK_REQUESTED: 8,
  TERMINATED: 9,
  ACTIVATION_REQUESTED: 10,
  SENT: 11,
  CANCELLATION_REQUESTED: 12,
  CANCELLED: 13,

  // Defined by DOM, not part of the ETC One API documentation (PDF-file)
  ERROR: 500
};
// Find Tariff Status Key
export function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

export const getTariffStatusKey = (statusId) => getKeyByValue(appTariffStatus, statusId);

export const appUsageType = {
  VOICE: 'VOICE',
  DATA: 'DATA',
  SMS: 'SMS',
  DATA_UNL: 'DATA_UNL',
  VOICE_UNL: 'VOICE_UNL',
  SMS_UNL: 'SMS_UNL',
  MEASUREMENT: 'MEASUREMENT'
};

export const appUsageMeasurementsUnits = {
  MB: 'MB',
  GB: 'GB',
  MIN: 'MIN',
  SMS: 'SMS'
};

// TDM API response type
export const internetDataUnit = {
  GB: 'GB',
  MB: 'MB',
  KB: 'KB'
};

// Method to get data in GB from required unit
export const formatBytes = (data, units) => {
  const marker = 1024; // Change to 1000 if required
  const decimal = 1; // Change as required
  if (units === internetDataUnit.KB) {
    return (data / (marker * marker)).toFixed(decimal);
  }
  if (units === internetDataUnit.MB) {
    return (data / marker).toFixed(decimal);
  }
  if (units === internetDataUnit.GB) {
    return data;
  }
  return data;
};

export const getMaximumValue = ({
  initialValue,
  remainingValue,
  initialUnit,
  remainingUnit,
  ...restData
}) => {
  let maxValue = restData != null && initialValue != null ? initialValue : 0;
  let currentValue = restData != null && remainingValue != null ? remainingValue : 0;

  if (restData != null && initialValue != null && remainingValue != null) {
    if (initialUnit.includes(internetDataUnit.GB) && remainingUnit.includes(internetDataUnit.GB)) {
      maxValue = parseFloat(maxValue);
      currentValue = parseFloat(currentValue);
    } else if (
      initialUnit.includes(internetDataUnit.MB) &&
      remainingUnit.includes(internetDataUnit.MB)
    ) {
      maxValue = formatBytes(parseFloat(maxValue), internetDataUnit.MB);
      currentValue = formatBytes(parseFloat(currentValue), internetDataUnit.MB);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (initialUnit.includes(internetDataUnit.GB)) {
        maxValue = formatBytes(parseFloat(maxValue), internetDataUnit.GB);
        currentValue = formatBytes(parseFloat(currentValue), internetDataUnit.MB);
      } else {
        maxValue = formatBytes(parseFloat(maxValue), internetDataUnit.MB);
        currentValue = formatBytes(parseFloat(currentValue), internetDataUnit.GB);
      }
    }
  }

  return {
    maximumValue: maxValue,
    currentValue
  };
};

// temporary fix for already fixed issue in dom-mo-sdk v0.1.89 but we can't use this version because of the breaking change
function formatNumber(number) {
  // Replace all non-numeric characters except the last one
  return number.replace(/(?!\.\d*$)[^\d]/g, '');
}

export const getMaxValue = (data) => {
  let maxValue = data != null && data.initialValue != null ? data.initialValue : 0;
  let currValue = data != null && data.remainingValue != null ? data.remainingValue : 0;

  if (data != null && data.initialValue != null && data.remainingValue != null) {
    if (data.type.includes('DATA')) {
      data.remainingValue = formatNumber(data.remainingValue);
    }
    if (data.initialUnit.includes('GB') && data.remainingUnit.includes('GB')) {
      maxValue = parseFloat(maxValue);
      currValue = parseFloat(currValue);
    } else if (data.type.includes('VOICE') || data.type.includes('VOICE')) {
      maxValue = parseFloat(maxValue);
      currValue = parseFloat(currValue);
    } else if (data.type.includes('SMS') || data.type.includes('SMS')) {
      maxValue = parseFloat(maxValue);
      currValue = parseFloat(currValue);
    } else if (data.initialUnit.includes('MB') && data.remainingUnit.includes('MB')) {
      maxValue = formatBytes(parseFloat(maxValue), 'MB');
      currValue = formatBytes(parseFloat(currValue), 'MB');
    } else if (data.initialUnit.includes('GB')) {
      maxValue = formatBytes(parseFloat(maxValue), 'GB');
      currValue = formatBytes(parseFloat(currValue), 'MB');
    } else {
      maxValue = formatBytes(parseFloat(maxValue), 'MB');
      currValue = formatBytes(parseFloat(currValue), 'GB');
    }
  }

  return {
    maximumValue: maxValue,
    currValue
  };
};

// Taken over from edeka-app implementation (2024-12-11)
// Calculating the date difference
export const dateTimeDifferenceCalculator = (firstDate, secondDate) => {
  const date2 = moment(firstDate, 'DD.MM.YYYY HH:mm:ss (MEZ)');
  const date1 = !secondDate ? moment() : moment(secondDate, 'DD.MM.YYYY  HH:mm:ss (Z)');

  const dateMoment = momentTz.tz(firstDate, 'DD.MM.YYYY HH:mm:ss', 'Europe/Berlin');

  // Calculate the difference in milliseconds
  const differenceInMillis = dateMoment.diff(date1);

  // Convert milliseconds into days, hours, and minutes
  const duration = moment.duration(differenceInMillis);

  const days = Math.floor(duration.asDays());
  const hours = Math.floor(duration.hours());
  const minutes = Math.floor(duration.minutes());

  let leftTime = {};

  leftTime = {
    value: days,
    hoursValue: hours,
    minutesValue: minutes
  };

  return leftTime;
};

// BFSG: UNUSED --> check at the end of Sprint 3 if it is still unused, if yes REMOVE
// #region
export function validateEmail(string) {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    string
  );
}

// prefix for number validations
export function validateNumberPrefix(string) {
  return /^.{1,6}$/.test(string);
}

// prefix for number validations
export function validatePhoneNumber(string) {
  return /^[0-9]{4,15}$/.test(string);
}
// #endregion

export const DAYFLAT_TITLE = 'DayFlat unlimited';
export const DAYFLAT_VALUE = '10.240';
export const appPassTypeID = {
  DAY_FLAT_UNLIMITED: 102
};

export const counterTDMArray = [
  {
    id: 1,
    title: 'ek_dashboard_data-volume',
    counterType: appUsageType.DATA
  },
  {
    id: 2,
    title: 'ek_dashboard_minutes',
    counterType: appUsageType.VOICE
  },
  {
    id: 3,
    title: 'ek_dashboard_sms',
    counterType: appUsageType.SMS
  }
];

export const validateYear = {
  DEFAULT_DOB_VALIDATION_YEAR: 16
};

export const displayPrice = (price) => {
  const amount = price;
  if (amount) {
    return parseFloat(amount).toFixed(2);
  }
  return 0;
};

export const appBreakPoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};

// eslint-disable-next-line consistent-return
export const findBreakPoint = (screenSize) => {
  if (screenSize >= appBreakPoints.xxl) {
    return 'xxl';
  }
  if (screenSize >= appBreakPoints.xl) {
    return 'xl';
  }
  if (screenSize >= appBreakPoints.lg) {
    return 'lg';
  }
  if (screenSize >= appBreakPoints.md) {
    return 'md';
  }
  if (screenSize >= appBreakPoints.sm) {
    return 'sm';
  }
  if (screenSize >= appBreakPoints.xs) {
    return 'xs';
  }
};

export const validateDOBde = () =>
  `${new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate()}.${
    new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1
  }.${new Date().getFullYear() - validateYear.DEFAULT_DOB_VALIDATION_YEAR}`;

export const progressPrecentageValue = (minValue, maxValue) => (minValue / maxValue) * 100;

export const appTariffs = {
  // Monthly
  TALK: 1803,
  KOMBI_S: 1812,
  KOMBI_M: 1813,
  KOMBI_L: 1814,
  KOMBI_XL: 1815,
  KOMBI_MAX: 1810,
  JAHRESTARIF_PREMIUM: 1816,
  JAHRESTARIF_START: 1811,
  TALK_JAHRESTARIF_START: 1817
};

// Payment method's  type
export const appPaymentMethods = {
  PAYPAL: 'paypal',
  SOFORT: 'sofort',
  CREDIT_CARD: 'creditcard',
  PAY_DIRECT: 'paydirekt',
  SEPA_DIRECT_DEBIT: 'sepa-direct-debit',
  AMERICAN_EXPRESS: 'american-express',
  APPLE_PAY: 'applepay',
  GOOGLE_PAY: 'googlepay',
  OPEN_BANKING: 'openbanking'
};

export const faqCategory = {
  THREE_G: '3G',
  GENERAL: 'Allgemeines',
  UNLOCK: 'Freischalten',
  CUSTOMER_PORTAL: 'Kundenportal',
  TARIFE: 'Tarife',
  ESIM: 'eSIM'
};

export const birthdayBonus = {
  AVAILABLE: 'NONE'
};

export const appTokenStatus = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  CANCELLED: 'cancelled'
};

export const deviceRegex = {
  ISIOS: /iPhone|iPad|iPod/i,
  ISANDRIOD: /Android/i
};

export const validCharRegex = {
  EMAIL: /^-|--|\.\.|[^a-zA-Z0-9ÖÄÜöäüß._+@-]|-@|(?<=@)-/g,
  EMAIL_VERIFICATION_CODE: /[^0-9]/g,
  MSISDN: /[^0-9]/g,
  PUK: /[^0-9]/g,
  OLD_NUMBER: /[^0-9]/g,
  FIRST_NAME: /[^a-zA-ZÄÖÜäöüß -]/g,
  LAST_NAME: /[^a-zA-ZÄÖÜäöüß -]/g,
  ZIP_CODE: /[^0-9]/g,
  PAYMENT_AMOUNT: /[^0-9]/g
};

// Validate invalid char in input fields
export function getForbiddenCharError(value, forbiddenPattern) {
  if (!value) return null;

  const matches = value.match(forbiddenPattern);
  const unique = [...new Set(matches || [])];

  if (unique.length > 0) {
    return `${unique.join(', ')}`;
  }
  return null;
}

export function generateUUID() {
  var d = new Date().getTime();
  var d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0; // Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function generateRandomValue() {
  const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let randomValue = '';

  for (let i = 0; i < 3; i += 1) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomValue += characters.charAt(randomIndex);
  }

  return randomValue;
}

export const getOptionLegalTextCmsKey = (passCodeOrId, passCodeSettings) => {
  // handle case of null or undefined
  if (!passCodeSettings || !passCodeSettings.additionalInfo) {
    return '';
  }

  const { additionalInfo } = passCodeSettings;
  if (additionalInfo[passCodeOrId]) {
    return additionalInfo[passCodeOrId].legalText;
  }
  return 'ek_tarif_options_order_text1'; // fallback key
};

export const isLocalHost = () => window.location.hostname === 'localhost';

// BFSG: OLD (OBSOLETE?) Generic error message --> needs to be replaced with the new logic of API error handling?
export const getGenericErrorMessage = (tA11y) => tA11y('ek_global_generic_api_err').content;

export const onEmailClick = (email) => {
  // this function is called when the user clicks on the support button to open call screen
  const mail = email;

  // Open the call screen
  window.location.href = `mailto:${mail}`;
};

export const keyValueValidation = (key, value) => {
  key && !key.includes(value);
};

// Checks if a specific key in an object is `true` while all other keys are `false`
export function isOnlySpecificKeyInObjTrue(obj, specificKey) {
  if (!obj || typeof obj !== 'object') return false;

  const isSpecificKeyTrue = obj[specificKey] === true;
  const areOtherKeysFalse = Object.entries(obj).every(
    ([key, value]) => key === specificKey || value === false
  );

  return isSpecificKeyTrue && areOtherKeysFalse;
}

export default {
  appRoute,
  storageKeys,
  appAlert,
  appDefaultAlertMessage,
  counterTDMArray,
  gettingNumberForGerman,
  progressPrecentageValue,
  getMaximumValue,
  getMaxValue,
  getOptionLegalTextCmsKey,
  isOnlySpecificKeyInObjTrue
};
